import { productInfoPlaceholder } from 'configuration/fieldCreators/productMetadata'

export const SPECIAL_SC_GROUP_BY_COLUMNS = [
    // no SC_GROUP_BY_COLUMNS do special rendering
]

export const SPECIAL_SC_GROUP_BY_COLUMN_PLACEHOLDERS = [
    productInfoPlaceholder(),
]
